module.exports = __webpack_public_path__ + "img/iconSet-02.ad76e9bc.png";